"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFilterDropdown = void 0;
var react_1 = __importDefault(require("react"));
var Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
var AcFilterDropdownMenu_1 = require("./AcFilterDropdownMenu");
var AcFilterDropdown_module_scss_1 = __importDefault(require("./AcFilterDropdown.module.scss"));
var AcFilterContext_1 = require("./AcFilterContext");
var AcDropdownToggle_1 = require("../dropdown/AcDropdownToggle");
var FaIcon_1 = require("../util/FaIcon");
var AcFilterDropdown = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'AcFilterDropdown' : _b, toggle = _a.toggle, _c = _a.toggleClassName, toggleClassName = _c === void 0 ? 'filter-dropdown' : _c, menuStyle = _a.menuStyle, menuClassName = _a.menuClassName, _d = _a.align, align = _d === void 0 ? 'left' : _d, hasFilter = _a.hasFilter, _e = _a.noFilterText, noFilterText = _e === void 0 ? 'フィルタ' : _e, _f = _a.filterText, filterText = _f === void 0 ? 'フィルタ適用中' : _f, onResetFilter = _a.onResetFilter, children = _a.children;
    var _g = AcFilterContext_1.useAcFilterContext(), menuOpen = _g.menuOpen, setMenuOpen = _g.setMenuOpen;
    return (react_1.default.createElement(Dropdown_1.default, { show: menuOpen, onToggle: function (isOpen) { return setMenuOpen(isOpen); }, alignRight: align === 'right' },
        react_1.default.createElement(Dropdown_1.default.Toggle, { as: AcDropdownToggle_1.AcDropdownToggle, id: id, className: toggleClassName + " " + AcFilterDropdown_module_scss_1.default.disableDropdownToggleIcon, variant: "sub4", toggleSize: "sm", active: hasFilter || menuOpen, disableDropdownIcon: true },
            react_1.default.createElement("span", { className: "position-relative mr-2" },
                react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-sliders-h", variant: "primary", size: "default", fixedWidth: true, active: hasFilter }),
                hasFilter && (react_1.default.createElement("i", { className: "fas fa-circle fa-fw text-attention position-absolute", style: { top: '-1px', right: '-5px', fontSize: 4 } }))),
            react_1.default.createElement(react_1.default.Fragment, null,
                !hasFilter && react_1.default.createElement(react_1.default.Fragment, null, noFilterText),
                hasFilter && react_1.default.createElement(react_1.default.Fragment, null, filterText)),
            hasFilter && (react_1.default.createElement("span", { className: "d-flex", onClick: onResetFilter },
                react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-times", size: "default", fixedWidth: true, variant: "apzashdarkblue", className: "ml-1" })))),
        react_1.default.createElement(Dropdown_1.default.Menu, { as: AcFilterDropdownMenu_1.AcFilterDropdownMenu, style: __assign({ minWidth: '14rem' }, menuStyle), className: menuClassName, alignRight: align === 'right', popperConfig: {
                strategy: 'fixed',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    },
                ],
            } }, children)));
};
exports.AcFilterDropdown = AcFilterDropdown;
exports.AcFilterDropdown.displayName = 'AcFilterDropdown';
//# sourceMappingURL=AcFilterDropdown.js.map